import React, { Component } from "react";
import FormStep from "../../common/components/formStep";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import AddMoreLoanAmount from "../../common/components/pageBlocks/vehicleDetails/addMoreLoanAmount";
import FinalSubmit from "../../common/components/pageBlocks/vehicleDetails/finalSubmit";
import commonContext, { AppContext } from "../../common/context/common";
import { leadType, offerType } from "../../app";
import { ALDDApis } from "../apis/aLDDApis";
import VehicleInfo from "../../common/components/pageBlocks/vehicleDetails/vehicleInfo";
import qs from "query-string";
import { Utilities } from "../../common/utils/utilities";
import { Authorization } from "../../common/utils/authorization";

interface IProps {
    location: any;
    history: any;
}
interface IState {}
export default class VehicleDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    offer: offerType;
    apis: ALDDApis;
    setLead: Function;
    setLeadError: Function;
    setOffer: Function;
    utils: Utilities;
    base: string;
    authKeeper: Authorization;
    validation: Array<{ name: string; valid: any; errorText: string }>;
    steps = [
        { title: "Vehicle", active: true },
        { title: "Loan" },
        { title: "Personal" },
        { title: "e-Mandate" },
        { title: "Confirmation" },
    ];
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.setLead = (this.context as AppContext).setLead;
        this.setLeadError = (this.context as AppContext).setLeadError;
        this.setOffer = (this.context as AppContext).setOffer;
        this.lead = (this.context as AppContext).lead as leadType;
        this.offer = (this.context as AppContext).offer as offerType;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.base = (this.context as AppContext).base;
        this.authKeeper = (this.context as AppContext)
            .authKeeper as Authorization;
        if (this.base == "dd-al") {
            this.setLead({
                roadTaxInsuranceAvailed: false,
                dealerInsuranceAvailed: false,
            });
        }
        if (!this.authKeeper.authorization) {
            const query = qs.parse(this.props.location.search);
            if (query.losAppId) {
                this.lead.losAppId = query.losAppId;
            }
            const apiData = await this.apis.validateOfferAndCheckSameDayEntry(
                this.lead
            );
            console.log(apiData);
            if (apiData.error?.error) {
                this.props.history.push("/error");
            }
            const offer: { avgCost?: number; motorInsurancePremAmt?: string } =
                apiData?.result?.offer;
            const leads = apiData?.result?.lead;
            this.authKeeper.setAuthorization(apiData?.result?.token);
            this.setOffer({ ...this.offer, ...offer });
            this.setLead({
                ...this.offer,
                ...leads,
                ...offer,
                losAppId: query.losAppId,
                VDOnRoadCost:
                    offer?.avgCost + parseFloat(offer?.motorInsurancePremAmt),
            });
            this.lead = {
                ...this.lead,
                ...this.offer,
                ...leads,
                ...offer,
                collateralCharges: parseFloat(leads.collateralCharges),
            };
        } else {
            console.log("ssr is avaliable", this.context);
            this.setLead({
                ...this.offer,
                ...this.context.offer,
                ...this.context.lead,
                VDOnRoadCost:
                    parseFloat(this.context.offer?.avgCost) +
                    parseFloat(this.context.offer?.motorInsurancePremAmt),
            });
            this.lead = {
                ...this.lead,
                ...this.offer,
                ...this.context.offer,
                ...this.context.lead,
            };
        }
        const apiData = await this.apis.getCarDealers({
            ...this.lead,
            city: this.lead.pdPresentCity,
            state: this.lead.pdPresentState,
        });
        console.log(apiData);
        if (!apiData.error?.error) {
            this.setLead({ dealers: apiData.result?.dealers });
        }
    }

    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        let step = this.lead.step == 1 ? this.lead.step : ++this.lead.step;

        // * validation code Start
        this.validation = [
            {
                name: "dealerSupplierId",
                valid: /\S/,
                errorText: `Please Select Valid Dealer.`,
            },
        ];
        const errors = this.utils.formValidation(this.lead, this.validation);
        console.log(errors);
        const isErrors = this.utils.checkPropertiesEmpty(errors);
        this.setLeadError(errors);
        if (!isErrors) return;
        // *validation code End

        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.saveVehicleDetails({
            ...this.lead,
            step: step,
        });
        await this.setLead({ loadingBtn: "" });
        if (!apiData.error?.error) {
            this.props.history.push("/error");
        }
        if (!apiData.result?.error) {
            this.setLead({ step: step });
            this.props.history.push("loan-details");
        }
    };

    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="vehicle-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <VehicleInfo />
                            </div>
                           
                            <AddMoreLoanAmount />
                            <FinalSubmit />
                        </form>
                    </section>
                </div>
            </>
        );
    }
}
